import React from 'react';
import { Redirect } from 'react-router-dom';
import LoginViews from '../views/Login';


class Login extends React.Component {

	render() {
		const isAlreadyAuthenticated = localStorage.getItem('token');
		return (
      
        <div>
          {isAlreadyAuthenticated ? <Redirect to={{ pathname: '/' }}/> : (
            <LoginViews />
          )}
        </div>
      
		);
	}
}

export default Login;
